import Cookies from 'js-cookie';
import { getAuthUrl } from '@podus/utils';

/**
 * Single source of truth for "the JWT is dead, bounce the user to auth."
 *
 * Triggered from every API client when the backend returns
 *   { response: { message: "Session Expired, Please login again" }, statusCode: 401 }
 * which is the exact shape NEW_PODUS_API's userMiddleware emits on
 * jwt.verify failure, tokensValidAfter mismatch, or revoked-token hash.
 *
 * Also covers MULTI_DOOR_API responses since it forwards token validation to
 * NEW_PODUS_API and surfaces the same message.
 *
 * Clears local auth state and redirects to the auth service, preserving the
 * current URL as the post-login return target. Idempotent — multiple parallel
 * API calls that all 401 collapse into a single redirect.
 */

const SESSION_EXPIRED_MESSAGE = 'Session Expired, Please login again';
const TOKEN_COOKIE = 'p-ai-accessToken';

let redirecting = false;

export function redirectToAuth(): void {
    if (redirecting) return;
    redirecting = true;
    Cookies.remove(TOKEN_COOKIE);
    const redirectParam = encodeURIComponent(window.location.href);
    window.location.href = `${getAuthUrl()}/sign-in?redirect=${redirectParam}`;
}

/**
 * Inspect a status + message and redirect on the session-expired 401.
 * Returns true if it redirected (caller can short-circuit).
 */
export function handleSessionExpired(statusCode: number | undefined, message: string | undefined): boolean {
    if (statusCode === 401 && message === SESSION_EXPIRED_MESSAGE) {
        redirectToAuth();
        return true;
    }
    return false;
}
